module.exports = __webpack_public_path__ + "img/approveno_bg.ec9fe625.png";